import { reactive, toRefs, onMounted, watch, nextTick, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getProductDetailBySpuId, getShopSkuListByGsCode, getShopDealerListBySku } from '@/api/directSales'
import { setSession, getSession } from '@/util'
import { showToast } from '@/util/couponCollection'
import _ from 'lodash'

export default function useShopDetail() {
  const store = useStore()
  const popUpRef = ref()
  const router = useRouter()
  const state = reactive({
    detailArr: [],
    slideList: [],
    dblclickImage: [],
    detailData: {},
    currentSkuLis: [], //受gscode影响
    allSkuLis: [],
    isEnterShoppingCar: false,
    isEnable: false, //计划是否生效中--true
    applyDealerParam: {},
    selectShopVariantItem: {},
    skuItem: {},
    isChecking: false
  })
  // 获取详情信息
  const getShopDetailFn = async (params, option) => {
    state.detailArr = params
    if (!params.spuId) return
    store.commit('SETSPUID', params.spuId)
    let data = await getProductDetailBySpuId(params)
    if (data?.orderErrorMsg) {
      showToast('二维码已失效', {
        defaultMsg: '获取二维码信息失败',
        type: 'fail',
        duration: 3000,
        position: 'middle',
        overlay: true,
        onOpened: () => {
          router.replace({ path: '/' })
        }
      })
    }
    // data.salesAttributes = [
    //   {
    //     code: 'serviceContent',
    //     name: '服务内容',
    //     values: [
    //       { lable: '2A', code: '2A' },
    //       { lable: '4A', code: '4A' },
    //       { lable: '6A', code: '6A' }
    //     ]
    //   },
    //   {
    //     code: 'oilType',
    //     name: '机油类型',
    //     values: [
    //       { lable: 'AMG机油', code: 'AMG' },
    //       { lable: '普通机油', code: 'MB' }
    //     ]
    //   }
    // ]
    state.detailData = data
    // state.isEnterShoppingCar = !!data.cartEnableStatusFlag
    state.isEnterShoppingCar = true
    state.isEnable = true
    state.slideList = data.banners
    state.dblclickImage = data.banners
    state.allSkuLis = data.skuList
    state.currentSkuLis = []
    let skuTemp = {}
    let selectShopVariantItem = {}
    if (data?.uploadSkuCount === 1 && data.skuList?.length === 1) {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = { code: item.values[0].code, lable: item.values[0].lable, pName: item.name, pid: item.code }
      }
      state.currentSkuLis = data.skuList
      store.commit('SETSkUITEM', { ...data.skuList[0] })
    } else {
      for (let index = 0; index < data.salesAttributes.length; index++) {
        const item = data.salesAttributes[index]
        selectShopVariantItem[item.code] = ''
      }
      if (params._skuId) {
        skuTemp = data.skuList.find(sku => sku.skuId === params._skuId)
        // console.log('skuTemp----', skuTemp)
        // skuTemp && store.commit('SETSkUITEM', { ...skuTemp })
        if (skuTemp) {
          for (let index = 0; index < data.salesAttributes.length; index++) {
            const item = data.salesAttributes[index]
            // oilType: {lable: "普通机油", code: "MB", disable: false, pid: "oilType", pName: "机油类型"}
            // serviceContent: {lable: "6A", code: "6A", disable: false, pid: "serviceContent", pName: "服务内容"}
            // skuTemp[item.code] && (selectShopVariantItem[item.code] = skuTemp[item.code])
            let itemCode = skuTemp[item.code]
            let target = item.values.find(({ code }) => code === itemCode) || {}
            let { code = '', lable = '' } = target
            selectShopVariantItem[item.code] = { code, lable, pName: item.name, pid: item.code }
          }
          console.log('selectShopVariantItem', selectShopVariantItem)
          store.commit('SETSkUITEM', { ...skuTemp })
        }
      }
    }
    // console.log('selectShopVariantItem', selectShopVariantItem)
    store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
    store.commit('SETSELECTSHOPVARIANTITEMFIRST', { ...selectShopVariantItem, ...store.state.stepperOption })
    let loyaltyDealerInfo = store.state.loyaltyDealerInfo
    console.log('loyaltyDealerInfo----', loyaltyDealerInfo)
    if (data?.carInfo) {
      store.dispatch('setCurrentCarInfo', data?.carInfo)
    }
    if (loyaltyDealerInfo) {
      state.applyDealerParam = {
        sign: 'shopDetail',
        skuId: '',
        gsCode: loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      }
      nextTick(() => {
        option._skuTemp = skuTemp
        option.gs_code = params.gsCode
        option.orderNo = params?.orderNo
        refreshPrice(loyaltyDealerInfo, option)
      })
    }
    relocation()
  }
  const relocation = () => {
    setTimeout(() => {
      try {
        let { lat = '' } = store.state.position
        if (!lat) {
          console.log('shopDetail-relocation')
          store.dispatch('getLocation')
        }
      } catch (error) {
        console.log('shopDetail-getLocation-error', error)
      }
    }, 3000)
  }
  const getPrice = data => {
    let suggestPrice = state.detailData?.suggestPrice
    let skuPrice = store.state.skuItem?.price
    let loyaltyDealerInfo = store.state.loyaltyDealerInfo
    let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
    suggestPrice = _.isNumber(suggestPrice) ? suggestPrice : '-'
    skuPrice = _.isNumber(skuPrice) ? skuPrice : '-'
    if (!gsCode) {
      return `厂商建议零售价 ¥${suggestPrice} 起`
    }
    if (skuPrice !== '-') {
      return `零售价 ¥${skuPrice}`
    } else {
      return `零售价 ¥${suggestPrice} 起`
    }
  }
  const shopPrice = computed(() => getPrice())

  const salesAttributesTxt = computed(() => {
    let skuCount = state.detailData?.uploadSkuCount
    let salesAttributes = state.detailData?.salesAttributes || []
    let comstomerAttributesName = salesAttributes
      .map(({ name, code }) => {
        let item = store.state.selectShopVariantItem[code]
        return item && item.pName ? `${item.pName}:${item.lable}` : name
      })
      .join('; ')
    return skuCount === 1 ? false : comstomerAttributesName
  })

  const shopInfoDatas = computed(() => ({
    ...state.detailData,
    orderNo: state.detailArr?.orderNo,
    isShowStep: state.isEnable,
    max: state.max,
    currentSkuLis: state.currentSkuLis,
    isChecking: state.isChecking
  }))

  const mergeSkuItem = (_skuItem, _skuLis) => {
    // console.log('mergeSkuItem', _skuItem, _skuLis)
    let skuItem = _skuItem || store.state.skuItem
    let currentSkuLis = _skuLis || state.currentSkuLis
    let baseItem = currentSkuLis.find(item => item.skuId === skuItem.skuId) || {}
    if (skuItem && skuItem.skuId && baseItem?.skuId) {
      let tempItem = state.allSkuLis.find(item => item.skuId === skuItem.skuId)
      skuItem = { ...tempItem, ...baseItem, ...skuItem, price: baseItem.price, maxPurchaseAmount: baseItem.maxPurchaseAmount }
      // console.log('mergeSkuItem', skuItem, baseItem)
      store.commit('SETSkUITEM', skuItem)
      return skuItem
    }
    return false
  }

  const resetSelectShopVariantItem = (data, salesAttributesData) => {
    //data-- {
    // "serviceContent": { "lable": "6A", "code": "6A" },
    // "oilType": { "lable": "AMG机油", "code": "AMG" }
    // }
    console.log('resetSelectShopVariantItem-----')
    let selectShopVariantItem = {}
    let salesAttributes = salesAttributesData || state.detailData.salesAttributes
    if (data) {
      for (let index = 0; index < salesAttributes.length; index++) {
        const item = salesAttributes[index]
        let selectCode = data[item.code]?.code || ''
        let selectLable = data[item.code]?.lable || ''
        selectShopVariantItem[item.code] = selectCode && selectLable ? { code: selectCode, lable: selectLable, pName: item.name, pid: item.code } : ''
      }
    } else {
      for (let index = 0; index < salesAttributes.length; index++) {
        const item = salesAttributes[index]
        selectShopVariantItem[item.code] = ''
      }
    }
    store.commit('SETSELECTSHOPVARIANTITEM', { ...selectShopVariantItem })
  }

  const hasDealer = computed(() => state.applyDealerParam && state.applyDealerParam.gsCode)
  const refreshPrice = async (dealerInfo, option) => {
    console.log('refreshPrice----start---', option)
    let gsCode = dealerInfo.gsCode || dealerInfo.gs_code
    let orderNo = option?.orderNo
    let spuId = store.state.spuId
    let skuId = store.state.skuItem?.skuId
    let { fin, threeGuaranteesDate } = store.state.currentCarInfo
    fin = state.detailArr?.fin
    if (option && option?.carInfo?.fin) {
      fin = option?.carInfo?.fin
      threeGuaranteesDate = option?.carInfo?.threeGuaranteesDate
    }
    state.applyDealerParam = {
      skuId,
      gsCode,
      sign: 'shopDetail'
    }
    state.isChecking = true

    // devTemp
    // fin = 'Wes212154sdfasdf'
    console.log('refreshPrice-by-gsCode', gsCode, spuId, fin)
    if (gsCode && spuId && fin) {
      // console.log('refreshPrice-by-gsCode', gsCode, spuId, fin)
      try {
        let res = await getShopSkuListByGsCode({ gsCode, spuId, fin, threeGuaranteesDate, orderNo })
        if (res?.length === 0) {
          showToast('所选经销商此商品可售为空')
          // store.commit('SETSELECTSHOPVARIANTITEM', {})
          resetSelectShopVariantItem()
          state.applyDealerParam = {
            skuId: '',
            gsCode,
            sign: 'shopDetail'
          }
          nextTick(() => {
            state.currentSkuLis = []
          })
        } else {
          // 检查范围：selectShopVariantItem是否在新的currentSkuLis范围内
          let _skuItem = store.state.skuItem
          if (option?._skuTemp && option?._skuTemp?.skuId) {
            _skuItem = option._skuTemp
          }
          let skuItem = mergeSkuItem(_skuItem, res)
          // console.log('mergeSkuItem---res', skuItem)
          // 不在范围内，重置参数
          !skuItem && _skuItem && _skuItem?.skuId && resetSelectShopVariantItem()
          nextTick(() => {
            state.currentSkuLis = res
          })
        }
        console.log('refreshPrice-by-carInfo---aaaaaaaaa', option?.carInfo)
        if (option && option?.carInfo?.fin) {
          store.dispatch('setCurrentCarInfo', option?.carInfo)
          console.log('refreshPrice-by-carInfo---bbbbbbbb', option?.carInfo)
        }
        console.log('通过经销商gscode刷新currentSkuLis---', res?.length)
      } catch (error) {
        showToast('获取SKU价格失败')
        state.currentSkuLis = []
      } finally {
        state.isChecking = false
      }
    } else {
      // showToast('请选择销售经销商')
      state.isChecking = false
      state.currentSkuLis = []
    }
  }
  watch(
    () => store.state.loyaltyDealerInfo,
    async v => {
      console.log('store.state.loyaltyDealerInfo', v)
      refreshPrice(v)
    },
    { deep: true }
  )
  watch(
    () => store.state.selectShopVariantItem,
    v => {
      //确认skuId,更新详情图片和描述
      // {"serviceContent": { "lable": "6A", "code": "6A" },
      //   "oilType": { "lable": "AMG机油", "code": "AMG" }
      // }
      // console.log('selectShopVariantItem---watch', v, state.currentSkuLis)
      const keys = Object.keys(v)

      state.selectShopVariantItem = v
      if (keys && keys.length && keys.length === state.detailData?.salesAttributes?.length) {
        const skuItem = state.currentSkuLis.find(sku => keys.map(attr => sku[attr] === v[attr]['code']).every(item => item === true)) || {}
        // store.commit('SETSkUITEM', skuItem)
        if (skuItem?.skuId) {
          mergeSkuItem(skuItem)
        } else {
          store.commit('SETSkUITEM', skuItem)
        }
        // console.log('selectShopVariantItem---watch---skuItem', skuItem)
      }
    },
    { deep: true }
  )
  watch(
    () => store.state.skuItem,
    _.debounce((skuItem, old) => {
      // skuItem => {
      // console.log('store.state.skuItem-watch---------', skuItem)
      // {
      //   skuId: '1544943930118098945',
      //   serviceContent: '4A',
      //   oilType: 'AMG',
      //   price: 2 //价格
      // },
      // {"serviceContent": { "lable": "6A", "code": "6A" },
      //   "oilType": { "lable": "AMG机油", "code": "AMG" }
      // }
      if (state.allSkuLis && state.allSkuLis.length) {
        const baseItem = state.allSkuLis.find(item => item.skuId === skuItem.skuId) || {}
        let skuItemTemp = { ...baseItem, ...skuItem }
        state.skuItem = skuItemTemp
        store.commit('SETSTEPPEROPTION', {
          ...store.state.stepperOption,
          max: skuItemTemp.maxPurchaseAmount == '-1' ? 999 : +skuItemTemp.maxPurchaseAmount || 0,
          min: skuItemTemp.minPurchaseAmount == '-1' ? 1 : +skuItemTemp.minPurchaseAmount || 1
        })
        state.isEnterShoppingCar = skuItemTemp?.cartFlag ? !!(skuItemTemp?.cartFlag === 'Y') : true
        let loyaltyDealerInfo = store.state.loyaltyDealerInfo
        state.applyDealerParam = {
          sign: 'shopDetail',
          skuId: skuItem?.skuId,
          gsCode: loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
        }
      }
      // },
    }, 300),
    { deep: true }
  )

  onMounted(async () => {})

  return {
    ...toRefs(state),
    getShopDetailFn,
    salesAttributesTxt,
    shopInfoDatas,
    hasDealer,
    shopPrice
  }
}
